import { jsxs as e, jsx as l } from "react/jsx-runtime";
const d = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#clip0_864_10233)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
            fill: "#F3F3FD"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M64.6705 76.3946C67.4 76.3946 69.0454 73.3715 67.5634 71.0793L54.4321 50.77C53.8615 49.8876 53.8424 48.7575 54.3829 47.8563L66.3971 27.8237C67.4988 25.9868 66.1756 23.6504 64.0337 23.6504H35.9663C33.8244 23.6504 32.5012 25.9868 33.6029 27.8237L45.6171 47.8563C46.1576 48.7575 46.1385 49.8876 45.5679 50.77L32.4366 71.0793C30.9546 73.3715 32.6 76.3946 35.3295 76.3946H64.6705Z",
            fill: "white",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "1.99035",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M51.0469 48.4531C51.0469 49.2137 50.4296 49.8311 49.6689 49.8311C48.9083 49.8311 48.291 49.2137 48.291 48.4531C48.291 47.6925 48.9083 47.0752 49.6689 47.0752C50.4296 47.0752 51.0469 47.6925 51.0469 48.4531Z",
            fill: "var(--plac-icon-fill-active)"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M48.291 42.9414C48.291 43.702 47.6737 44.3193 46.9131 44.3193C46.1525 44.3193 45.5352 43.702 45.5352 42.9414C45.5352 42.1808 46.1525 41.5635 46.9131 41.5635C47.6737 41.5635 48.291 42.1808 48.291 42.9414Z",
            fill: "var(--plac-icon-fill-active)"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M53.8027 41.5635C53.8027 42.3241 53.1854 42.9414 52.4248 42.9414C51.6642 42.9414 51.0469 42.3241 51.0469 41.5635C51.0469 40.8029 51.6642 40.1855 52.4248 40.1855C53.1854 40.1855 53.8027 40.8029 53.8027 41.5635Z",
            fill: "var(--plac-icon-fill-active)"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M51.0469 57.4102C51.0469 58.1708 50.4296 58.7881 49.6689 58.7881C48.9083 58.7881 48.291 58.1708 48.291 57.4102C48.291 56.6495 48.9083 56.0322 49.6689 56.0322C50.4296 56.0322 51.0469 56.6495 51.0469 57.4102Z",
            fill: "var(--plac-icon-fill-active)"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M63.1098 73.6068C64.1992 73.6068 64.8577 72.4024 64.2699 71.4852L57.5082 60.9367C56.8034 59.8378 55.2698 59.6593 54.3314 60.5667L49.6988 65.0464C48.6929 66.0185 47.1173 66.0833 46.0356 65.1959L43.7213 63.2985C42.7644 62.5137 41.3382 62.7397 40.6699 63.7814L35.7319 71.4853C35.1441 72.4024 35.8026 73.6068 36.892 73.6068H63.1098Z",
            fill: "var(--plac-icon-fill-active)"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M28 23.5H72",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M28 76.5H72",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_864_10233", children: /* @__PURE__ */ l("rect", { width: "100", height: "100", fill: "white" }) }) })
    ]
  }
);
export {
  d as ExpireIllustration
};
//# sourceMappingURL=index.es493.js.map
